module.exports = __webpack_public_path__ + "static/media/speaker-johnson-mobile.20444c2a.jpg";